import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useIsMobile } from '@/hooks/use-mobile';
import Image from 'next/image';
import Link from 'next/link';
const AppImage = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="relative w-full aspect-video md:aspect-auto md:h-full overflow-hidden bg-muted"><Image src="/images/pierre_app_modal.png" alt="Pierre App" fill={true} className="object-cover" priority={true} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const NewBadge = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Badge variant="secondary" className="text-xs font-semibold w-fit bg-[#17A44B] text-white hover:bg-[#17A44B]">NOVO</Badge>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const MobileContent = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AppImage />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="space-y-3"><NewBadge /><h2 className="font-semibold text-3xl">Baixe o app Pierre</h2><p className="text-base text-muted-foreground">Toque no botão abaixo e conheça a novidade</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex  flex-col">{t0}<div className="p-6 flex flex-col gap-4">{t1}<Link href="https://nimble.li/p9lx4pv9" target="_blank" rel="noopener noreferrer"><Button size="xl" rounded="xl" className="w-full font-semibold bg-[#17A44B] hover:bg-[#158f3f] text-white">BAIXAR O APP</Button></Link></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const DesktopContent = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex justify-center"><NewBadge /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="space-y-3 text-center"><h2 className="font-semibold text-4xl leading-tight">Baixe o app Pierre</h2><p className="text-base text-muted-foreground">Escaneie o QR Code com a câmera do seu celular e conheça a novidade</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex-1 bg-background p-8 flex flex-col justify-center"><div className="space-y-6">{t0}{t1}<div className="flex justify-center py-2"><div className="relative size-56 bg-white p-3 shadow-sm"><Image src="/images/qr-code-dowload-app.svg" alt="QR Code para baixar o app Pierre" fill={true} className="object-contain bg-background  border-2 border-secondary" priority={true} /></div></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-row min-h-[500px]">{t2}<div className="flex-1"><AppImage /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
interface AppDownloadModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}
export function AppDownloadModal(t0) {
  const $ = _c(7);
  const {
    open,
    setOpen
  } = t0;
  const isMobile = useIsMobile();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DialogTitle />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isMobile) {
    t2 = <DialogContent closeClassName="size-6 text-black" className="lg:max-w-4xl sm:max-w-[90%] p-0 rounded-2xl gap-0 overflow-hidden">{t1}{isMobile ? <MobileContent /> : <DesktopContent />}</DialogContent>;
    $[1] = isMobile;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== open || $[4] !== setOpen || $[5] !== t2) {
    t3 = <Dialog open={open} onOpenChange={setOpen}>{t2}</Dialog>;
    $[3] = open;
    $[4] = setOpen;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}